import React from 'react';
import { Card, CardContent, Skeleton, Box } from '@mui/material';

const ProductCardSkeleton: React.FC = () => {
  return (
    <Card sx={{ display: 'flex', alignItems: 'center', mb: 2, p: 1 }}>
      {/* Image skeleton */}
      <Skeleton variant="rectangular" width={64} height={64} sx={{ mr: 2, borderRadius: 1 }} />

      {/* Text skeleton */}
      <CardContent sx={{ flex: 1, padding: '8px 0' }}>
        <Skeleton variant="text" width="60%" height={24} />
        <Skeleton variant="text" width="40%" height={20} />
        <Skeleton variant="text" width="40%" height={20} />
      </CardContent>
    </Card>
  );
};

export default ProductCardSkeleton;
